import React from 'react';
var OverlayContext = /*#__PURE__*/React.createContext({});
OverlayContext.displayName = 'OverlayContext';
export default OverlayContext;